import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IID_UNLOCK_CODE } from "@common/interfaces/interfaceData";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { Topics } from "@common/interfaces/topics";
import { environment } from "src/environments/environment";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { InterfaceDataService } from "../interfaceDataRegistry";
import { ProjectEntityStoreStrategy } from "../updateStoreStrategies";
import { IIDUnlockCodeQuery } from "./iidUnlockCode.query";
import { IIDUnlockCodeStore } from "./iidUnlockCode.store";

@Injectable({ providedIn: 'root' })
@InterfaceDataService(InterfaceName.UNLOCK_CODE)
export class IIDUnlockCodeService extends CrudService<IID_UNLOCK_CODE, IIDUnlockCodeStore, IIDUnlockCodeQuery> {
  constructor(
    public store: IIDUnlockCodeStore,
    public query: IIDUnlockCodeQuery,
    actionService: ActionService,
    updateStrategy: ProjectEntityStoreStrategy,
    private readonly http: HttpClient,
  ) {
    super(Topics.IID_UNLOCK_CODE, store, query, actionService, updateStrategy);
  }

  submit(issueId: string, code: string) {
    return this.http.post<IID_UNLOCK_CODE>(`${environment.apiUrl}/api/v1/orders/${issueId}/unlock-submit`, { code });
  }
}
